import {apiProvider} from "@/services/utilities/Provider";

const getById = (scenarioId) => {
    return apiProvider.get(`/Scenario/${scenarioId}`);
}

const getScoringModel = (scenarioId) => {
    return apiProvider.get(`/Scenario/${scenarioId}/scoring-model`);
}

/**
 * Paged scenario list. Accepts either the legacy positional form `getList(page, pageSize)`
 * or an options object `getList({ page, pageSize, name, sortBy, sortDirection, responsibleUserId, ownerId, createdFrom, createdTo })`.
 */
const getList = (arg = {}, legacyPageSize) => {
    const opts = typeof arg === "number"
        ? { page: arg, pageSize: legacyPageSize ?? 20 }
        : (arg ?? {});

    const {
        page = 1,
        pageSize = 20,
        name = "",
        sortBy = "updatedAt",
        sortDirection = "desc",
        responsibleUserId = null,
        ownerId = null,
        createdFrom = null,
        createdTo = null,
    } = opts;

    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    params.set("sortBy", sortBy);
    params.set("sortDirection", sortDirection);
    if (name) params.set("name", name);
    if (responsibleUserId) params.set("responsibleUserId", responsibleUserId);
    if (ownerId) params.set("ownerId", ownerId);
    if (createdFrom) params.set("createdFrom", createdFrom);
    if (createdTo) params.set("createdTo", createdTo);

    return apiProvider.get(`/Scenario?${params.toString()}`);
}

const create = (scenarioName, type) => {
    return apiProvider.post(`Scenario`, {name: scenarioName, type});
}

const remove = (scenarioId) => {
    return apiProvider.remove(`Scenario`, scenarioId);
}

const duplicate = (scenarioId) => {
    return apiProvider.post(`Scenario/${scenarioId}/duplicate`, {});
}

const reorderIntents = (scenarioId, intentIds) => {
    return apiProvider.put(`Scenario/${scenarioId}/intents/reorder`, { intentIds });
}

const addIntent = (intent, scenarioId) => {
    return apiProvider.post(`Intent`, intent);
}

const rename = (scenarioId, name, type) => {
    return apiProvider.put(`Scenario/${scenarioId}`, { name, type });
}

const importScenario = (name, type, intents) => {
    return apiProvider.post('Scenario/import', { name, type, intents });
}

const getUnassigned = (page = 1, pageSize = 20, name = '') => {
    return apiProvider.get(`/Scenario/unassigned?page=${page}&pageSize=${pageSize}&name=${encodeURIComponent(name)}&sortDirection=asc`);
}

const getByOwner = (ownerId) =>
    apiProvider.get(`/Scenario/by-owner/${ownerId}`);

const getWithoutOwner = (page = 1, pageSize = 20, name = '') =>
    apiProvider.get(`/Scenario/without-owner?page=${page}&pageSize=${pageSize}&name=${encodeURIComponent(name)}&sortDirection=asc`);

const assignToOwner = (scenarioId, ownerId) =>
    apiProvider.put(`Scenario/${scenarioId}/owner/${ownerId}`, {});

const unassignFromOwner = (scenarioId) =>
    apiProvider.remove(`Scenario/${scenarioId}`, 'owner');

const setResponsibleUser = (scenarioId, userId) =>
    apiProvider.put(`Scenario/${scenarioId}/responsible/${userId}`, {});

const clearResponsibleUser = (scenarioId) =>
    apiProvider.remove(`Scenario/${scenarioId}`, 'responsible');

export default {
    getById,
    getScoringModel,
    getList,
    getUnassigned,
    getByOwner,
    getWithoutOwner,
    assignToOwner,
    unassignFromOwner,
    setResponsibleUser,
    clearResponsibleUser,
    create,
    remove,
    addIntent,
    duplicate,
    reorderIntents,
    rename,
    importScenario
}
